import { useMutation } from '@tanstack/react-query'

import { setQueriesData } from '@shared/providers/src/QueryClientProvider'
import API from '@shared/services/src/API'
import { filterCache, QK } from '@shared/utils'

export default function useDeleteMessage(conversationId) {
  return useMutation({
    mutationFn: (id) => API.conversations.id(conversationId).messages.id(id).delete(),
    onSuccess: (_, messageId) => {
      setQueriesData(
        { queryKey: QK.conversations.id(conversationId).messages.lists },
        filterCache((message) => message.id !== messageId)
      )
    },
  })
}
